/**
 * Utility functions for job site information handling
 */

import {OrderIntakeSite} from '../types/OrderIntakeSite.types'

/**
 * Helper function to format job site information for display
 * @param jobSite - The job site object containing site information
 * @returns A formatted string representation of the job site information
 */
export const formatJobSiteInfo = (jobSite: OrderIntakeSite | null): string => {
  if (!jobSite) {
    return 'Job site not specified'
  }

  const parts: string[] = []

  if (jobSite.siteName) {
    parts.push(jobSite.siteName)
  }

  if (jobSite.street) {
    parts.push(jobSite.street)
  }

  if (jobSite.postalCode && jobSite.city) {
    parts.push(`${jobSite.postalCode} ${jobSite.city}`)
  } else if (jobSite.city) {
    parts.push(jobSite.city)
  }

  return parts.join(', ')
}
